import React from 'react';
import { Box, Button } from '@material-ui/core';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useDispatch } from 'react-redux';
import styles from '../styles';
import { SET_FOCUSED_ATTRIBUTE_MODE } from '../../../redux/action-types/focused-attribute-types';
import { Modes } from '../../../redux/reducers/focusedAttributeReducer';
import { useFocusedAttribute } from '../hooks/useFocusedAttribute';
import { isEditable } from '../isEditable';

const ViewSubmit = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const { attribute } = useFocusedAttribute(Modes.VIEW);

  const handleSubmit = () => {
    dispatch({ type: SET_FOCUSED_ATTRIBUTE_MODE, payload: Modes.EDIT });
  };

  return (
    <Button
      variant="outlined"
      className={classes.buttonStyleBlack}
      style={{ marginLeft: '5px' }}
      onClick={() => handleSubmit()}
      data-testid="submit-button"
      disabled={!isEditable(attribute)}
    >
      <Box display="flex" justifyContent="center">
        <EditOutlined fontSize="small" />
        <span style={{ marginLeft: '5px' }}>EDIT ATTRIBUTE</span>
      </Box>
    </Button>
  );
};

export default ViewSubmit;
